import sum from 'root-core/utils/array/sum.js'
import flatten from 'lowscore/flatten.js'
import compact from 'lowscore/compact.js'
import groupBy from 'lodash/groupBy.js'
import {hotelPickupsProductCategoryIds} from 'root-config/constants.js'
import ValidationError from '../../services/web/server/public-api/validationError.js'

export default (rooms, insuranceName, departure, priceOptions) => {
  var passengers = flatten(rooms.map(r => r.passengers), true)

  function travelProtectionProduct () {
    const passengerWithTravelProtection = groupBy(passengers.filter(passenger => passenger.requestedTravelProtection), 'travelProtection')

    return Object.entries(passengerWithTravelProtection).map(([insuranceType, passengersWithProtection]) => {
      const travelProtection = passengersWithProtection[0].requestedTravelProtection
      return {
        name: `${insuranceName}${insuranceType === 'ENCF' ? ' Plus' : ''}`,
        productCode: travelProtection.code,
        amount: additionalProductSubtotal(passengersWithProtection, 'requestedTravelProtection'),
        commisionableAmount: commisionableAmountSubTotal(passengersWithProtection, 'requestedTravelProtection'),
        adults: passengersWithProtection.filter(p => p.requestedTravelProtection && p.type == 'adult').length,
        children: passengersWithProtection.filter(p => p.requestedTravelProtection && p.type == 'child').length,
        typeCode: travelProtection.typeCode,
        category: travelProtection.category,
        brochureCode: travelProtection.brochureCode,
        productType: 'travelProtection',
      }
    })
  }

  function prepaidGratuitiesProduct () {
    const passengerWithGratuities = passengers.find(p => p.requestedPrepaidGratuities)

    if (passengerWithGratuities) {
      const gratuities = passengerWithGratuities.requestedPrepaidGratuities
      return {
        name: 'Pre-Paid Gratuities',
        productCode: gratuities.productCode,
        amount: additionalProductSubtotal(passengers, 'requestedPrepaidGratuities'),
        adults: passengers.filter(p => p.requestedPrepaidGratuities && p.type == 'adult').length,
        children: passengers.filter(p => p.requestedPrepaidGratuities && p.type == 'child').length,
        typeCode: gratuities.typeCode,
        category: gratuities.category,
        brochureCode: gratuities.brochureCode,
        productType: 'prepaidGratuities',
      }
    }
  }

  function memberBenefits (departure) {
    return departure.prices.memberBenefits.map(b => {
      return {
        name: b.productName,
        amount: 0,
        adults: passengers.filter(p => p.type == 'adult').length,
        children: passengers.filter(p => p.type == 'child').length,
        productId: b.productId,
        associatedProductId: b.associatedProductId,
        productCode: b.productCode,
        productType: 'memberBenefit',
      }
    })
  }

  function hotelPickupProduct () {
    const hotelPickupId = priceOptions?.hotelPickup?.associatedProductId
    const hotelPickup = (departure.prices.additionalProducts || [])
      .find(p => hotelPickupsProductCategoryIds.includes(p.category) &&
        hotelPickupId === p.associatedProductId
      )

    if (hotelPickup) {
      return {
        name: hotelPickup.associatedProductName,
        amount: 0,
        adults: passengers.filter(p => p.type == 'adult').length,
        children: passengers.filter(p => p.type == 'child').length,
        productId: hotelPickup.productId,
        associatedProductId: hotelPickup.associatedProductId,
        productCode: hotelPickup.productCode,
        productType: 'hotelPickup',
      }
    } else if (hotelPickupId) {
      throw new ValidationError([{
        property: 'hotelPickup',
        message: 'Unknown hotel ID',
      }])
    }
  }

  return compact([
    hotelPickupProduct(),
    prepaidGratuitiesProduct(),
    ...travelProtectionProduct(),
    ...memberBenefits(departure),
  ])
}

function additionalProductSubtotal (passengers, property) {
  return sum(
    passengers.map(passenger => {
      if (passenger[property]) {
        return passenger[property].amount
      } else {
        return 0
      }
    })
  )
}

function commisionableAmountSubTotal (passengers, property) {
  return sum(
    passengers.map(passenger => {
      if (passenger[property]) {
        return passenger.ontarioResident ? passenger[property].basePrice : passenger[property].amount
      } else {
        return 0
      }
    })
  )
}
